import { computed, Ref } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { useAllowlist } from '@tt4b/ttam-hooks';
import { AcoFormData, FullNormalFormData, IDENTITY_TYPE_MAP, MaterialType } from '@tt4b/ttam-enums';
import { useTikTokIdentityDisplayProps } from './../../../identity/hooks';

export function usePropsIsShowIdentity(options: { isNative: Ref<boolean>; isAcoWithTtaNativeAds: Ref<boolean> }) {
  const { isNative, isAcoWithTtaNativeAds } = options;
  const isShowIdentity = computed(() => isNative.value && !isAcoWithTtaNativeAds.value);

  return {
    isShowIdentity,
  };
}

export function usePropsLibraryTitle(options: { type: Ref<MaterialType> }) {
  const { type } = options;
  /** 抽屉标题 */
  const title = computed(
    () =>
      ({
        [MaterialType.Native]: i18n.t('module_creative_available_post'),
        [MaterialType.Image]: i18n.t('ad_creative_lib_title_image'),
        [MaterialType.Video]: i18n.t('ad_creative_lib_title_video'),
        [MaterialType.Playable]: i18n.t('ad_creative_lib_title_playable'),
        [MaterialType.CarouselImage]: i18n.t('ad_creative_lib_title_image'),
      }[type.value || MaterialType.Video]),
  );

  return {
    title,
  };
}

export function usePropsIsShowCommonFilter(options: { type: Ref<MaterialType> }) {
  const { type } = options;
  const isShowCommonFIlter = computed(() =>
    [MaterialType.Image, MaterialType.CarouselImage, MaterialType.Video, MaterialType.Playable].includes(type.value),
  );

  return {
    isShowCommonFIlter,
  };
}

export function usePropsIsShowTtNativeFilter(options: {
  type: Ref<MaterialType>;
  isNative: Ref<boolean>;
  creativeData: Ref<FullNormalFormData>;
}) {
  const { type, isNative, creativeData } = options;
  const { isCreativeHasIdentityWhite } = useAllowlist();

  /** 原生单视频授权 */
  const isShowTtNativeFilter = computed(() => {
    if (type.value !== MaterialType.Native) {
      return false;
    }

    const isNotIdentityStructureNative = !isCreativeHasIdentityWhite.value && isNative.value;
    const isIdentityStructureTTA = creativeData.value?.identityType === IDENTITY_TYPE_MAP.AUTH_CODE_USER;

    return isNotIdentityStructureNative || isIdentityStructureTTA;
  });

  return {
    isShowTtNativeFilter,
  };
}

export function usePropsAcoMaterialList(options: {
  isAco: Ref<boolean>;
  isNative: Ref<boolean>;
  formData: Ref<AcoFormData>;
}) {
  const { isAco, isNative, formData } = options;

  /** aco下已选视频id列表 */
  const acoVideoIdList = computed(() => {
    if (!isAco.value) {
      return [];
    }

    return (formData.value?.imageList || []).map(item =>
      isNative.value ? item.videoInfo?.awemeItemId : item.videoInfo?.vid,
    );
  });

  /** aco下已选的图片列表 */
  const acoImageIdList = computed(() => {
    if (!isAco.value) {
      return [];
    }
    const materialList = formData.value?.imageList || [];

    return materialList
      .filter(item => !item?.videoInfo && item?.imageInfo)
      .map(item => item.imageInfo?.[0]?.webUri || '');
  });

  return {
    acoVideoIdList,
    acoImageIdList,
  };
}

export function usePropsIdentityInfo(options: { creativeData: Ref<FullNormalFormData> }) {
  const { creativeData } = options;

  const curIdentity = computed(() => ({
    identityId: creativeData.value.identityId as string,
    identityType: creativeData.value.identityType as number,
    identityBcId: creativeData.value.identityBcId as string,
    identityTtsShopId: creativeData.value.identityTtsShopId as string,
  }));

  const curIdentityData = computed(() => creativeData.value.identityData || {});
  const { avatar, displayName } = useTikTokIdentityDisplayProps({
    identityInfo: curIdentity,
    identityData: curIdentityData,
  });

  return {
    avatar,
    name: displayName,
  };
}
